/**
 * Announcement banners store a legacy `colour`, which predates the Notification
 * `variant` names and the trimmed-down colour picker. Both mappings live here so
 * the banner and its settings preview can never drift apart.
 */

/** Stored announcement `colour` → ORCS Notification `variant`. */
export const colourToNotificationVariant = (colour) => {
  if (colour === "danger" || colour === "error") return "error";
  if (!colour || colour === "info" || colour === "primary") return "default";
  return colour;
};

/** Stored announcement `colour` → the option the colour picker offers. */
export const storedColourToOption = (colour) => {
  if (colour === "error") return "danger";
  if (colour === "info" || colour === "primary") return "default";
  return colour;
};
